webpackJsonp([213534597649335],{

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeadlineWithFocus = __webpack_require__(686);
	
	var _HeadlineWithFocus2 = _interopRequireDefault(_HeadlineWithFocus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "c-content-box" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Hi... from James"
	    ),
	    _react2.default.createElement(
	      _HeadlineWithFocus2.default,
	      {
	        modifierClassNames: "\n        c-headline-focus \n        c-headline-focus--super-big \n      "
	      },
	      "I'm an application developer"
	    ),
	    _react2.default.createElement(
	      "h2",
	      {
	        className: "\n        js-action-button-anchor\n        c-content-box__subheadline \n        c-content-box__subheadline--with-button\n      "
	      },
	      "for Web apps",
	      _react2.default.createElement("br", null),
	      "on cloud platforms"
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-0ca20c2ffe46765e12a6.js